'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var desktop = require('@alfalab/core-components-button/desktop');
var coreComponentsShared = require('@alfalab/core-components-shared');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var styles = {"footer":"select__footer_ilczp","button":"select__button_ilczp"};
require('./index.css')

var Footer = function (_a) {
    var handleApply = _a.handleApply, handleClear = _a.handleClear, showClear = _a.showClear, _b = _a.selectedDraft, selectedDraft = _b === void 0 ? [] : _b, dataTestId = _a.dataTestId;
    return (React__default.default.createElement("div", { 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0, className: styles.footer },
        React__default.default.createElement(desktop.ButtonDesktop, { size: 32, view: 'primary', onClick: handleApply, dataTestId: coreComponentsShared.getDataTestId(dataTestId, 'apply'), className: styles.button }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C"),
        showClear && selectedDraft.length > 0 && (React__default.default.createElement(desktop.ButtonDesktop, { size: 32, view: 'secondary', onClick: handleClear, dataTestId: coreComponentsShared.getDataTestId(dataTestId, 'clear'), className: styles.button }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C"))));
};

exports.Footer = Footer;
